module.exports = __webpack_public_path__ + "img/portalBaked.51be7af3.jpg";